import Form from "../CustomForm";
import useForm from "src/hooks/use-form";
import {useAlertContext} from "src/hooks/use-alert";
import OrganizationValidator from "src/validators/organization-validator.ts";
import { CreateOrg,UpdateOrg } from "src/apis/org_apis";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";


const validator = new OrganizationValidator();

var properties = {
  name: { value: "", type: "text", isTouched: false, hasError: false },

  phoneNumber: {
    value: "",
    type: "text",
    isTouched: false,
    isPhone: true,
    hasError: false,
  },
  cellNumber: {
    value: "",
    type: "text",
    isTouched: false,
    isPhone: true,
    hasError: false,
  },
  address: {
    value: "",
    type: "text",
    isTouched: false,
    hasError: false,
  },
  email: {
    value: "",
    type: "text",
    isTouched: false,
    hasError: false,
  },
  vatNumber:{value: "", type: "text", isTouched: false, hasError: false},

  codiceFiscale:{ value: "", type: "text", isTouched: false, hasError: false},
  description: {
    value: "",
    type: "text",
    multiline: true,
    isTouched: true,
    hasError: false,
  },

  
};

export default function Organization({ props }) {
  const [first, setfirst] = useState(false);
  const navigate = useNavigate();
  const alert = useAlertContext();
  useEffect(() => {
    if (props.site) {
      for (const prop in props.site) {
        if (properties[prop] !== undefined) {
          properties[prop].value = props.site[prop];
          properties[prop].isTouched = true;
        }
      }
    }
  }, [props.site]);

  const { inputs, errorMessages, isValid, hasError, submitValidationHandler } =
    useForm(validator, properties);

  const handleSubmit = async (event) => {
    event.preventDefault();
    submitValidationHandler(event);
    if (isValid && !hasError) {
      let data = {};

      for (const input in inputs) {
        data[input] = inputs[input].value;
      }
      var response;
      var message;

      if (!props.org) {
        response = await CreateOrg(data);
        message = "Organization created successfully!";
      } else {
        
        response = await UpdateOrg(data);
        message = "Organization updated successfully!";
      }
      console.log("submit:" + JSON.stringify(response));
      if (response.success) {
        // success alert
        alert.setSuccess((prev) => [...prev,{
          status: true,
          message: message,
          index:prev.length
        }]);
        if (isNaN(props.steps)) {
          return props.custom ? props.onSubmit(false, true) : navigate("..");
        }
        return props.handleNext({
          id: response.object.id,
          name: data.name,
        });
      } else {
        alert.setError((prev) => [...prev,{ status: true, messages: response.errors,index:prev.length }]);
        return props.custom ? props.onSubmit(false) : null;
      }
    }
    return props.custom ? props.onSubmit(false) : null;
  };

  return (
    <>
      <Form
        title={"Company Information"}
        inputs={inputs}
        errorMessages={errorMessages}
        isValid={isValid}
        custom={props.custom ?? false}
        hasError={hasError}
        activeStep={props.activeStep}
        steps={props.steps}
        onSubmit={handleSubmit}
        externalSubmit={props.externalSubmit ?? null}
        handleBack={props.handleBack ?? null}
      />
    </>
  );
}
